module.exports = __webpack_public_path__ + "school/img/culturalConfidence.221a9c36.jpg";